import { useIsomorphicLayoutEffect } from 'shared/hooks';

export function useDocumentTitle(title: string): void {
  useIsomorphicLayoutEffect(() => {
    const defaultTitle = 'AuditCover Tax Audit Insurance';
    window.document.title = defaultTitle + ' | ' + title;
  }, [title]);
}
